<template>
<nav class="st-topbar">
  <div class="container">
    <a href="javascript:void(0)" @click="$router.push('/')" style="text-decoration:none;display:flex;align-items:center;gap:8px;">
      <img src="assets/images/simi_trac_logo.png" alt="Simi Trac" style="height:32px;" />
    </a>
    <span class="st-inst-name" v-if="institutionName">{{ institutionName }}</span>
    <div class="ms-auto d-flex align-items-center gap-2">
      <!-- Outstanding-to-platform badge — appears only when the school owes the platform something.
           Click → jumps straight to the invoices page. Shows in red when overdue (>30 days). -->
      <a v-if="userRole === 'super_admin' && platformOwed > 0" href="javascript:void(0)" @click="$router.push('/billing/platform-invoices')" class="st-owed-badge" :class="{'st-owed-overdue': platformOldestAge > 30}" :title="`You owe Simitrac KSh ${platformOwed.toLocaleString()} — click to view invoices and pay`">
        <i class="mdi mdi-receipt-text me-1"></i>KSh {{ Number(platformOwed).toLocaleString() }}
      </a>
      <span class="st-sms-badge" v-if="smsBalance !== null"><i class="mdi mdi-message-text me-1"></i>{{ smsBalance }} SMS</span>
      <div class="st-nav-user" @click="showDrop=!showDrop">
        <div class="st-nav-avatar">{{ initials }}</div>
        <span class="d-none d-md-inline" style="color:#E8EDF4;font-size:13px;">{{ userName }}</span>
        <i class="mdi mdi-chevron-down" style="color:#8BA4C4;"></i>
      </div>
      <div v-if="showDrop" class="st-nav-drop">
        <div style="padding:10px 16px;border-bottom:1px solid #1A3A6A;"><div style="color:#E8EDF4;font-weight:600;">{{ userName }}</div><div style="color:#8BA4C4;font-size:12px;">{{ userRole }}</div></div>
        <a v-if="userRole === 'platform_owner'" href="javascript:void(0)" @click="$router.push('/admin');showDrop=false" class="st-nav-drop-item" style="color:#4FC3F7;font-weight:700;"><i class="mdi mdi-shield-crown me-2"></i>Platform Admin</a>
        <a v-if="canAccess('dashboard')" href="javascript:void(0)" @click="$router.push('/dashboard');showDrop=false" class="st-nav-drop-item"><i class="mdi mdi-view-dashboard me-2"></i>Dashboard</a>
        <a v-if="userRole === 'super_admin'" href="javascript:void(0)" @click="$router.push('/billing/platform-invoices');showDrop=false" class="st-nav-drop-item">
          <i class="mdi mdi-receipt-text me-2"></i>Platform Invoices
          <span v-if="platformOwed > 0" style="float:right;background:rgba(245,158,11,.2);color:#F59E0B;border-radius:10px;padding:1px 8px;font-size:11px;font-weight:700;">KSh {{ Number(platformOwed).toLocaleString() }}</span>
        </a>
        <a v-if="canAccess('settings')" href="javascript:void(0)" @click="$router.push('/settings');showDrop=false" class="st-nav-drop-item"><i class="mdi mdi-cog me-2"></i>Settings</a>
        <div style="border-top:1px solid #1A3A6A;margin:4px 0;"></div>
        <a href="javascript:void(0)" @click="logout" class="st-nav-drop-item" style="color:#FF6B6B;"><i class="mdi mdi-logout me-2"></i>Sign Out</a>
      </div>
    </div>
  </div>
</nav>
</template>
<script>
/* eslint-disable */
import { executeJson, simitrack } from "@/api";
export default {
  name: "Navigation",
  data() { return { showDrop: false, userName: '', initials: '', userRole: '', institutionName: '', smsBalance: null, allowedMenus: [], platformOwed: 0, platformOldestAge: 0 }; },
  mounted() {
    this.userName = sessionStorage.getItem('userName') || '';
    this.userRole = sessionStorage.getItem('userRole') || '';
    this.institutionName = sessionStorage.getItem('institutionName') || '';
    try { this.allowedMenus = JSON.parse(sessionStorage.getItem('allowedMenus') || '[]'); } catch(e) { this.allowedMenus = []; }
    var parts = this.userName.split(' ');
    this.initials = parts.length >= 2 ? (parts[0][0] + parts[1][0]).toUpperCase() : this.userName.slice(0,2).toUpperCase();
    if (this.userRole === 'super_admin') this.loadPlatformOwed();
  },
  methods: {
    canAccess(menuKey) {
      if (!this.allowedMenus || this.allowedMenus.length === 0) return true;
      return this.allowedMenus.includes(menuKey);
    },
    async loadPlatformOwed() {
      // School-side fetch — surfaces what this institution owes the platform
      // so the super_admin sees it on every page (badge in the top nav).
      try {
        const r = await executeJson({ function: 'getMyPlatformInvoices' }, simitrack);
        if (r.data.success && r.data.data) {
          this.platformOwed = Number(r.data.data.outstanding || 0);
          // Compute oldest unpaid invoice age in days for the "overdue" styling
          const invoices = r.data.data.invoices || [];
          let oldest = 0;
          const now = Date.now();
          invoices.forEach(inv => {
            if (inv.status !== 'paid' && inv.status !== 'void' && inv.issued_at) {
              const ageDays = Math.floor((now - new Date(inv.issued_at).getTime()) / 86400000);
              if (ageDays > oldest) oldest = ageDays;
            }
          });
          this.platformOldestAge = oldest;
        }
      } catch (e) { /* silent — badge just won't appear */ }
    },
    logout() {
      sessionStorage.clear(); localStorage.removeItem('authToken');
      this.showDrop = false;
      this.$router.push('/login');
    }
  }
};
</script>
<style scoped>
.st-topbar{position:fixed;top:0;left:0;right:0;z-index:100;background:rgba(10,22,40,.97);backdrop-filter:blur(20px);border-bottom:1px solid #1A3A6A;padding:8px 0;}
.st-topbar .container{display:flex;align-items:center;gap:12px;}
.st-inst-name{color:#8BA4C4;font-size:14px;font-weight:500;padding-left:12px;border-left:1px solid #1A3A6A;}
.st-sms-badge{background:rgba(46,134,222,.1);color:#4FC3F7;padding:4px 12px;border-radius:50px;font-size:12px;font-weight:600;border:1px solid rgba(46,134,222,.2);}
.st-owed-badge{background:rgba(245,158,11,.12);color:#F59E0B;padding:4px 12px;border-radius:50px;font-size:12px;font-weight:700;border:1px solid rgba(245,158,11,.35);text-decoration:none;transition:.15s;display:inline-flex;align-items:center;}
.st-owed-badge:hover{background:rgba(245,158,11,.22);border-color:#F59E0B;}
.st-owed-overdue{background:rgba(239,68,68,.15);color:#EF4444;border-color:rgba(239,68,68,.4);animation:owed-pulse 2.5s infinite;}
.st-owed-overdue:hover{background:rgba(239,68,68,.25);border-color:#EF4444;}
@keyframes owed-pulse{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,.4);}50%{box-shadow:0 0 0 6px rgba(239,68,68,0);}}
.st-nav-user{display:flex;align-items:center;gap:8px;cursor:pointer;padding:4px 10px;border-radius:20px;border:1px solid #1A3A6A;position:relative;}
.st-nav-user:hover{border-color:#2E86DE;}
.st-nav-avatar{width:28px;height:28px;border-radius:50%;background:rgba(46,134,222,.2);color:#4FC3F7;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;}
.st-nav-drop{position:absolute;top:50px;right:0;background:#0F2347;border:1px solid #1A3A6A;border-radius:10px;min-width:200px;z-index:200;box-shadow:0 8px 30px rgba(0,0,0,.5);overflow:hidden;}
.st-nav-drop-item{display:flex;align-items:center;padding:8px 16px;color:#8BA4C4;text-decoration:none;font-size:13px;transition:all .2s;}
.st-nav-drop-item:hover{background:rgba(46,134,222,.1);color:#E8EDF4;}
</style>